var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 554"},[React.createElement("path",{"id":"Path_328","data-name":"Path 328","d":"M180.981,129.145l-23.6-13.628a1.931,1.931,0,0,0-1.975,0,1.975,1.975,0,0,0-.988,1.712v27.222a1.975,1.975,0,0,0,.988,1.712,1.983,1.983,0,0,0,1.975,0l23.569-13.628a1.965,1.965,0,0,0,.033-3.39Zm-22.614,11.916V120.652l17.644,10.2Z","transform":"translate(-136.477 -101.856)","key":0}),React.createElement("path",{"id":"Path_329","data-name":"Path 329","d":"M29,0A29,29,0,1,0,58,29,29.024,29.024,0,0,0,29,0Zm0,54.05A25.05,25.05,0,1,1,54.05,29,25.062,25.062,0,0,1,29,54.05Z","key":1})]));
}

PlayInline.defaultProps = {"width":"58","height":"58","viewBox":"0 0 58 58"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
